import React from 'react';
import './ComplianceGauge.css';

function ComplianceGauge({ title, compliant, nonCompliant, total, onClick }) {
  const safeTotal = total > 0 ? total : 0;
  const percentage = safeTotal > 0 ? Math.round((compliant / safeTotal) * 100) : 0;

  const radius = 52;
  const circumference = Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  let tone = 'warning';
  if (percentage >= 80) tone = 'great';
  else if (percentage >= 60) tone = 'ok';

  const clickable = typeof onClick === 'function';
  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`compliance-gauge-card tone-${tone}${clickable ? ' clickable' : ''}`}
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      title={clickable ? `View assets not compliant with ${title}` : undefined}
    >
      <h3 className="compliance-gauge-title">{title}</h3>
      <div className="compliance-gauge-visual">
        <svg viewBox="0 0 120 70" className="compliance-gauge-svg" aria-hidden="true">
          <path
            className="compliance-gauge-track"
            d="M 10 60 A 50 50 0 0 1 110 60"
            fill="none"
            strokeWidth="10"
            strokeLinecap="round"
          />
          <path
            className="compliance-gauge-fill"
            d="M 10 60 A 50 50 0 0 1 110 60"
            fill="none"
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="compliance-gauge-center">
          <span className="compliance-gauge-percent">{percentage}%</span>
          <span className="compliance-gauge-sub">Compliant</span>
        </div>
      </div>
      <div className="compliance-gauge-counts">
        <span className="compliance-count compliant">Compliant: {compliant}</span>
        <span className="compliance-count non-compliant">Not compliant: {nonCompliant}</span>
      </div>
      <p className="compliance-gauge-footnote">{safeTotal} active devices</p>
    </div>
  );
}

export default ComplianceGauge;
